class fileChangeDirective{

  constructor(){
    'ngInject';
    this.restrict = 'A';
  }

  /**
   *
   * @param scope
   * @param element
   */
  link( scope, element ){
    element.on('change', () => {
      const uploadId = element.attr('data-upload');
      element.parent().triggerHandler('submit');
    });
  }

  static create(){
    return new fileChangeDirective(...arguments);
  }

}

export { fileChangeDirective };


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/file-change/file-change.directive.js
 **/